import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39455158"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "flex items-center justify-center video-aspect-ratio bg-oaiGray-900 relative vjs-waiting"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "vjs-loading-spinner" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "flex items-start video-aspect-ratio bg-oaiGray-900"
}
const _hoisted_5 = { class: "rounded-md bg-yellow-400/50 p-4 text-center text-xs sm:text-sm text-gray-50 flex-1 m-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VideoPlayer = _resolveComponent("VideoPlayer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.showPlayer)
      ? (_openBlock(), _createBlock(_component_VideoPlayer, {
          key: 0,
          src: _ctx.src!,
          controls: "",
          class: "video-js vjs-big-play-centered vjs-4-3",
          playbackRates: _ctx.hls ? [] : [0.25, 0.5, 1, 2, 5, 10],
          muted: "",
          fluid: "",
          fill: "",
          type: _ctx.hls ? 'application/x-mpegURL' : undefined,
          onError: _ctx.handleError,
          controlBar: { volumePanel: false },
          onMounted: _ctx.handleMounted,
          html5: { nativeTextTracks: false },
          preload: _ctx.autoPlay ? 'auto' : 'none'
        }, null, 8, ["src", "playbackRates", "type", "onError", "onMounted", "preload"]))
      : _createCommentVNode("", true),
    (!_ctx.showPlayer)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_ctx.loading && !_ctx.hasError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.hasError || !_ctx.noSrcMessage ? _ctx.$t("video_player.unable_to_play_message") : _ctx.noSrcMessage), 1)
              ]))
        ], 64))
      : _createCommentVNode("", true)
  ], 64))
}